import React from 'react';
import LcLoading from '../../../components/Generic/LcLoading';
import LcNoData from '../../../components/Generic/LcNoData';
import { defaultTooltipConfig } from '../../../components/Generic/eChartsConfig';
import { Chart } from '../../endpointDetectionResponse/resumeEvent/Models';
import ReactECharts from 'echarts-for-react';
import { SaasService } from '../../../services/saas/saasService';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { UserState } from '../../../store/reducers/userReducer';
import { useQuery } from 'react-query';
import { EChartsOption } from 'echarts';

interface ActiveUsersPerDayChartModel {
    userPeriod: number
}

const getOptionsChart = (usersChart): EChartsOption => {
    return {
        grid: {
            top: '10%',
            left: '2%',
            right: '2%',
            bottom: '20%',
            containLabel: true
        },
        tooltip: {
            ...defaultTooltipConfig,
            textStyle: {
                fontSize: 11,
                fontFamily: 'Ubuntu',
                color: 'var(--text-default)',
                fontWeight: 'normal'
            },
            trigger: 'axis',
            formatter: function (params) {
                return params.map(item => `${item.marker} ${item.seriesName}: ${item.value}`).join('<br/>');
            }
        },
        xAxis: {
            type: 'category',
            data: usersChart.labels,
            axisLabel: {
                fontSize: '10px',
                fontFamily: 'Ubuntu',
                color: '#8b90a3',
            },
        },
        legend: {
            type: 'scroll',
            bottom: 0,
            left: 'center',
            icon: 'circle',
            textStyle: {
                fontSize: 12,
                fontFamily: 'Ubuntu',
                color: '#8b90a3'
            },
            pageIconSize: 12,
            pageIconColor: '#273b85',
            pageTextStyle: {
                color: '#8b90a3'
            },
            itemWidth: 20,
            itemHeight: 10,
            itemGap: 40
        },
        yAxis: {
            type: 'value',
            axisLabel: {
                fontSize: '10px',
                fontFamily: 'Ubuntu',
                color: '#8b90a3',
            },
        },
        series: usersChart.datasets,
    }
}

const UsersChartData = (response: any): Chart => {
    if (response !== null) {
        let usersChart = {
            labels: response.map((Item: any) => {
                let date = new Date(Item.reportDate);
                return date.getDate().toString().padStart(2, '0') + "/" + (date.getMonth() + 1).toString().padStart(2, '0');
            }),
            datasets: [
                {
                    name: 'Aplicativos do Microsoft 365',
                    data: response.map((Item: any) => {
                        return Item.office365
                    }),
                    type: 'line',
                    // smooth: true,
                    color: '#00DBFF',
                },
                {
                    name: 'Microsoft Teams',
                    data: response.map((Item: any) => {
                        return Item.teams
                    }),
                    type: 'line',
                    // smooth: true,
                    color: "#966cf3"
                },
                {
                    name: 'Exchange',
                    data: response.map((Item: any) => {
                        return Item.exchange
                    }),
                    type: 'line',
                    // smooth: true,
                    color: '#28a8ea'
                },
                {
                    name: 'OneDrive',
                    data: response.map((Item: any) => {
                        return Item.oneDrive
                    }),
                    type: 'line',
                    // smooth: true,
                    color:'#471fcc'
                },
                {
                    name: 'SharePoint',
                    data: response.map((Item: any) => {
                        return Item.sharePoint
                    }),
                    type: 'line',
                    color: '#34c38f'
                },
            ]
        };
        return usersChart;

    } else {
        let usersChart = {
            labels: [],
            datasets: []
        };
        return usersChart;
    }
}

export const ActiveUsersPerDayChart: React.FC<ActiveUsersPerDayChartModel> = (
    {
        userPeriod,
    }) => {
    const user = useSelector<RootState, UserState>(state => state.user);
    const { data: chartData, isLoading } = useQuery({
        queryKey: ['usersChart', userPeriod, user.ClientGroupSelected, user.refreshFlag],
        refetchOnWindowFocus: false,
        staleTime: 2*(60*1000),
        cacheTime: 5*(60*1000), 
        queryFn: async () => {
            const saasService = new SaasService({});
            const response = await saasService.GetUsersChart(userPeriod);
            const usersChart = UsersChartData(response);
            return getOptionsChart(usersChart);
        },
        onError: (error) => {
            console.error('Erro ao carregar dados do gráfico:', error);
        }
    });
    return(
        <LcLoading loading={isLoading}>
            {chartData && Object.keys(chartData).length > 0 ?
                <ReactECharts
                    style={{ width: '100%', height: '98%' }}
                    opts={{ renderer: 'svg', locale: 'PT-br' }}
                    option={chartData}
                />
                :
                <LcNoData size="small" label="Sem dados no período." />
            }
        </LcLoading>
    )
}
